import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import ReactPaginate from "react-paginate";

import { getComeBackDoctorAction } from "../../Actions/AffiarsSurgeryAction/ComeBackDoctor";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { CiFilter } from "react-icons/ci";
import LoadingPage from "../Loading/LoadingPage";
import Pagination from "../Pagination";

const ComeBackDoctorPage = () => {
  const branchId = localStorage.getItem("branch_id");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [indexx, setIndexx] = useState(null);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Gender",
      name: "gender",
    },
    {
      label: "phone",
      name: "phone",
    },
    {
      label: "birth date",
      name: "birthDate",
    },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getComeBackDoctorAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        branchId
      )
    );
  }, [perPage]);
  const getComeBackDoctor = useSelector((state) => state.getComeBackDoctor);
  const { comeBackDoctors, loading, total } = getComeBackDoctor;

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getComeBackDoctorAction(
        event.selected + 1,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        branchId
      )
    );
  };
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    gender: "",
    phone: "",
    birthDate: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getComeBackDoctorAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        branchId
      )
    );
    setIsOpenFilter(false);
  };
  const handleClearSearch = (name) => {
    const updateParam = { ...filter };
    updateParam[name] = "";
    setFilter(updateParam);
    dispatch(
      getComeBackDoctorAction(
        page,
        perPage,
        updateParam.fullname,
        updateParam.code,
        updateParam.gender,
        updateParam.phone,
        updateParam.birthDate,
        branchId
      )
    );
    setIsOpenFilter(false);
  };
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div>
              <p className="font-bold">Come back File</p>
            </div>
          </div>

          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button
                                  onClick={() => handleClearSearch(th.name)}
                                  className="btn-danger px-1.5 py-1"
                                >
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                    <th className="coustm-th">Doctor </th>

                    <th className="coustm-th">Note</th>
                  </tr>
                </thead>

                <tbody>
                  {comeBackDoctors ? (
                    <>
                      {comeBackDoctors?.map((item, index) => {
                        return (
                          <tr key={index} className="coustm-tr">
                            <td className="coustm-td">{index + 1}</td>
                            <td className="coustm-td">
                              {item.patient.patient_info.code}
                            </td>
                            <td className="coustm-td">
                              {item.patient.patient_info.fullname}
                            </td>
                            <td className="coustm-td">
                              {item.patient.patient_info.gender}
                            </td>
                            <td className="coustm-td">
                              {item.patient.patient_info.phone}
                            </td>

                            <td className="coustm-td">
                              {item.patient.patient_info.birth_date}
                            </td>
                            <td className="coustm-td">
                              {item.follow_up_commite.length > 0
                                ? item.follow_up_commite[0].doctor
                                    .map((doctor) => doctor)
                                    .join(" , ")
                                : ""}
                            </td>
                            <td className="coustm-td">
                              {item.come_back_doctor.note}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    "NO Data Yet"
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {total > 0 ? (
            <Pagination
              total={total}
              page={page}
              perPage={perPage}
              onPageChange={onPageChange}
              setPerPage={setPerPage}
            />
          ) : (
            ""
          )}
        </div>
      )}

      <div className="bottom-space"></div>
    </>
  );
};

export default ComeBackDoctorPage;
